import { fromJS } from 'immutable';
import * as actions from './actions';
import { BUSINESS_UUID } from '../../utils/constants';

export const initialState = fromJS({
  loading: false
});

export default function saveFormData(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_CASE:
      return state.set('loading', true);
    case actions.FETCH_CASE_FAILED:
      return state.set('loading', false).set('error', action.error);
    case actions.FETCH_CASE_SUCCESS: {
      const registeredAddress =
        action.payload.applicant.personal_details !== null &&
        action.payload.applicant.personal_details.addresses &&
        action.payload.applicant.personal_details.addresses[0].uk_address;
      if (registeredAddress) {
        return state
          .set('loading', false)
          .set('caseData', fromJS(action.payload))
          .set('personalAddress', fromJS(registeredAddress))
          .set('registerOrganisationName', registeredAddress.organisation_name)
          .set('registerFlatNumber', registeredAddress.address_prefix)
          .set('registerBuildingNumber', registeredAddress.house_number)
          .set('registerStreetName', registeredAddress.street_name)
          .set('registerCityName', registeredAddress.city)
          .set('registerPostcode', registeredAddress.postal_code)
          .set('registerAddressLine1', registeredAddress.address_line_1)
          .set('registerAddressLine2', registeredAddress.address_line_2)
          .set('registerAddressHouseName', registeredAddress.house_name)
          .set('registerAddressReference', registeredAddress.id)
          .set('tradingFirstName', action.payload.applicant.personal_details.name.first_name)
          .set('tradingLastName', action.payload.applicant.personal_details.name.last_name)
          .set(BUSINESS_UUID, fromJS(action.payload.customer_id.business));
      }
      return state
        .set('loading', false)
        .set('caseData', fromJS(action.payload))
        .set(BUSINESS_UUID, fromJS(action.payload.customer_id.business));
    }
    default:
      return state;
  }
}
